import { combineReducers } from 'redux';
import auth from './auth';
import sidebar from './sidebar';
import loading from './loading';
import error from './error';
import result from './result';
import transaction from './transaction';
import transactionStatusCsv from './transactionStatusCsv';
import subscription from './subscription';
import processing from './processing';
import customer from './customer';
import product from './product';
import productCategory from './productCategory';
import productOption from './productOption';
import productTag from './productTag';
import salesPerson from './salesPerson';
import agency from './agency';
import paymentPage from './paymentPage';
import payment from './payment';
import coupon from './coupon';
import prefecture from './prefecture';
import pagination from './pagination';
import qrQuery from './qrQuery';
import invoice from './invoice';
import ruleGroup from './ruleGroup';
import rule from './rule';
import dashboard from './dashboard';
import customerStatus from './customerStatus';
import news from './news';
import delivery from './delivery';
import ecInformation from './ecInformation';
import ecShoppingGuide from './ecShoppingGuide';
import ecCommercialTransactionLaw from './ecCommercialTransactionLaw';
import companyFAQ from './companyfaq';
import warehouse from './warehouse';
import wholesalePrice from './wholesalePrice';
import document from './document';
import columnReducer from './columns';

export default combineReducers({
  auth,
  sidebar,
  loading,
  error,
  result,
  transaction,
  transactionStatusCsv,
  subscription,
  processing,
  customer,
  product,
  productCategory,
  productTag,
  salesPerson,
  agency,
  paymentPage,
  payment,
  coupon,
  prefecture,
  pagination,
  qrQuery,
  invoice,
  ruleGroup,
  rule,
  dashboard,
  customerStatus,
  news,
  delivery,
  productOption,
  ecInformation,
  ecShoppingGuide,
  ecCommercialTransactionLaw,
  companyFAQ,
  warehouse,
  wholesalePrice,
  document,
  column: columnReducer,
});
